export const transformPrice = (format: number, currency = 'usd') =>
  new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
  }).format(format / 100)
